<template>
  <v-app-bar app clipped-left color="primary" dark>
    <div class="d-flex align-center">
      <template v-if="isEnterMode">
        <div class="headline">Аккредитация. Ввод заявок</div>
      </template>
      <template v-else>
        <div class="headline">Аккредитация. Поиск заявок</div>
      </template>

    </div>
  </v-app-bar>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: "AppHeader",

  data: () => ({
  }),

  computed: {
    ...mapGetters({
      userId: "account/userId",
      online: "account/online",
      orgId: "account/corgId",
      isEnterMode: "account/isEnterMode",
    }),
  },

};
</script>
